import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Label } from "components/ui/Label/Label";
import { getLabelForProductType } from "utility/productTypes";

export default function ProductSearchResultCard(props) {
    const data = props.data;

    return (
        <MDBox>
            <MDBox>
                <MDTypography color='text' fontSize={14} fontWeight='fontWeightMedium'>{'['+getLabelForProductType(data.type)+']'} {data.name}</MDTypography>
            </MDBox>
        </MDBox>
    )
}